import React, { useEffect, useState } from 'react';

function OneMapWidget(props) {
    const { onSelect } = props;
    const [libLoaded, setLibLoaded] = useState(false);
    const [allReadyLoaded, setAllReadyLoaded] = useState(false);

    useEffect(() => {
        const t = document.getElementById("onemap-script");
        if (t) {
            setAllReadyLoaded(true);
            return;
        }
        const script = document.createElement('script');

        script.id = "onemap-script";
        script.src = "https://www.1map.co.za/widgetcors/assets/widget.js";
        script.async = true;
        script.type = "module";

        document.body.appendChild(script);
        setLibLoaded(true);

        return () => {
            setLibLoaded(false);
        }
    }, []);

    useEffect(() => {
        if (!libLoaded) return;
        window.onemapWidget = {
            widgetParts: [
                {
                    type: 'map',
                    target: 'onemapwidget',
                    token: '8ffbd22ca3327f4713d9d32767e530da',
                    locale: 'en',
                    devMode: false,
                    showFooter: false,
                    mainColor: '255, 51, 154',
                    logo: 'https://static.wixstatic.com/media/99be2d_9cad48539724438584575c6ee2b4acf2~mv2.png/v1/fill/w_197,h_197,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/ZOE%20Logo.png',
                    activeLayer: {
                        enabled: false
                    },
                    activeFilter: {
                        enabled: false
                    },
                    /* Use to set search options in the search dropdown - available options: 'address', 'farm', 'latlon', 'standno', 'sg21key', premiseId */
                    searchOptions: ['address', 'latlon', 'premiseId', 'standno','google','pluscode'],
                    workspace: {
                        enabled: false,
                        default: 'Flycoolwidget'
                    },
                    listeners: {
                        onPopupResult: (result) => {
                            onSelect(result);
                        },
                        onReady: (result) => {
                            const script = document.createElement('script');
                            script.src = document._portalConfig.oneMapUrl;
                            script.crossOrigin = 'anonymous';
                            script.onload = function () {
                                if (typeof initClient === 'function') {
                                    initClient(result); // eslint-disable-line
                                } else {
                                    console.error('initClient is not defined');
                                }
                            };
                            document.body.appendChild(script);

                            var myWidget = result

                            myWidget.selectFeatures([
                                {
                                    layerId: 5121,
                                    fieldName: 'site',
                                    fieldValues: [
                                        'Kwazakele'
                                    ]
                                }
                            ], {
                                showOnlySelected: false,
                                showPopup: true,
                                zoomToExtent: true
                            })

                            myWidget.onFeaturesSelected = (result) => {
                                console.log("AAAA onFeaturesSelected result: ", result)
                                if (result) {
                                }
                            }

                            myWidget.onFeaturesDeselected = (result) => {
                                console.log("AAAA onFeaturesDeselected result: ", result)
                                if (result) {
                                    /* console.log(`Feature(s) Deselected: ${JSON.stringify(result)}`) */
                                }
                            }
                        }
                    },
                    settings: {
                        mapControls: {
                            baseLayerControl: {
                                enabled: false,
                                className: 'ol-switch-baselayers',
                            },
                            fullScreen: {
                                enabled: false,
                                className: 'ol-full-screen',
                                tipLabel: 'Toggle full-screen'
                            },
                            geoLocation: {
                                className: 'ol-geolocation',
                                enabled: false,
                                label: 'fa fa-crosshairs',
                                tipLabel: 'Use my location',
                            },
                            layerControl: {
                                enabled: false,
                                className: 'ol-layerswitcher',
                                position: 'right',
                                expanded: true,
                                extent: false,
                                reorder: false,
                                opacity: false,
                                legend: false,
                                showProgress: false
                            },
                            legend: {
                                enabled: false,
                                className: 'ol-legend',
                                tipLabel: 'Toggle Legend'
                            },
                            measureControl: {
                                enabled: false,
                                className: 'ol-measure-control',
                                tipLabel: 'Measure tool'
                            },
                            mousePosition: {
                                enabled: false,
                                className: 'ol-mouse-position',
                                tipLabel: 'Mouse Position'
                            },
                            // navHistory: {
                            //   enabled: false,
                            //   prevClassName: 'ol-navhistory-prev',
                            //   nextClassName: 'ol-navhistory-next',
                            //   prevTipLabel: 'Move to Previous Extent',
                            //   nextTipLabel: 'Move to Next Extent'
                            // },
                            // openExtentInBing: {
                            //   enabled: true,
                            //   className: 'ol-extentinbing-open',
                            //   tipLabel: 'Open Extent in Bing Maps',
                            // },
                            // openExtentInGoogle: {
                            //   enabled: true,
                            //   className: 'ol-extentingoogle-open',
                            //   tipLabel: 'Open Extent in Google Maps',
                            // },
                            overviewMap: {
                                enabled: false,
                                className: 'ol-overview-map',
                                tipLabel: 'Map Overview',
                            },
                            // printDialog: {
                            //   enabled: false,
                            //   className: 'ol-print ol-button',
                            //   tipLabel: 'Print Map',
                            // },
                            rotate: {
                                enabled: false,
                                className: 'ol-rotate',
                                label: '⇧',
                                tipLabel: 'Reset rotation',
                                compassClassName: 'ol-compass',
                                duration: 250,
                                autoHide: true
                            },
                            searchBar: {
                                className: 'ol-searchbar',
                                tipLabel: 'Enter search term',
                                enabled: true,
                                typeSelector: {
                                    className: 'ol-searchbar-selection',
                                    tipLabel: 'Select search type',
                                    enabled: true,
                                    filter: ['address']
                                }
                            },
                            // spatialAnalysis: {
                            //   enabled: false,
                            //   className: 'ol-spatial-analysis',
                            //   tipLabel: 'Spatial Analysis',
                            // },
                            // videoRecorder: {
                            //   enabled: false,
                            //   className: 'ol-videorec ol-button',
                            //   tipLabel: 'Record Map',
                            // },
                            zoom: {
                                enabled: true,
                                duration: 250,
                                className: 'ol-zoom',
                                zoomInClassName: 'ol-zoom-in',
                                zoomOutClassName: 'ol-zoom-out',
                                zoomInLabel: '+',
                                zoomOutLabel: '–',
                                zoomInTipLabel: 'Zoom in',
                                zoomOutTipLabel: 'Zoom out'
                            },
                            zoomSlider: {
                                enabled: true,
                                duration: 200,
                                className: 'ol-zoomslider',
                                tipLabel: 'Slide to zoom'
                            }
                        },
                        mapPosition: {
                            lon: 25,
                            lat: -28,
                            zoom: 5,
                            rotation: 0
                        },
                        pointerSelect: {
                            type: 'None',
                            showDirections: true
                        },
                        searchBar: {
                            className: 'ol-searchbar',
                            enabled: true,
                            typeSelector: {
                                className: 'ol-searchbar-selection',
                                enabled: true,
                                filter: ['address']
                            }
                        }
                    },
                    // cb: function(result) {
                    //   let onemapMap1 = result;

                    //   if (onemapMap1?.mapView) {
                    //     onemapMap1.mapView.setCenter(olProj.transform([25, -28], 'EPSG:4326', 'EPSG:3857'));
                    //   }
                    // }
                }
            ]
        };
    }, [libLoaded]);

    useEffect(() => {
        if (!allReadyLoaded) return;
        window.onemapWidgetRun();
    }, [allReadyLoaded]);

    return (
        <>
            <div id="onemapwidget" style={{ width: "100%", height: "600px" }}></div>
        </>
    );
}

export default OneMapWidget;
